import VoicesCalendar from "../Components/Voices/Calendar/VoicesCalendar";

const VoicesCalendarPage = () => {
  return <VoicesCalendar />;
};

export default VoicesCalendarPage;
